module.exports = __webpack_public_path__ + "static/media/halfTelephone.a20facb1.webp";